
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../../Components/Table/CustomTable';
import actions from '../../../../ReduxStore/actions';
import CustomInputForm from '../../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';
import { bulkUploadDesignationsAction } from '../../../../ReduxStore/Slices/Designation/bulkUploadDesignations';
import { adminUrl } from '../../../../constants';
import InvalidRowsModal from '../../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';

const validationSchema = Yup.object().shape({
    designation: Yup.string()
        .trim()
        .when('file', {
            is: (file) => !file, // if file is null or undefined
            then: (schema) => schema.required('Designtion name is required.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    file: Yup.mixed().nullable(),
});


const Designation = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const tableHeadData = ["S.No", "Destination", "Actions"];
    const tableData = [
        { destination: "ASSEMBLY SUPERVISOR" },
        { destination: "ASSEMBLY SUPERVISOR" },
        { destination: "ASSEMBLY SUPERVISOR" },
        { destination: "ASSEMBLY SUPERVISOR" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Designation"));
    }, [dispatch]);
    const [editData, setEditData] = useState()
    const { updateDesignation } = useSelector((state) => state?.updateDesignation);
    const { createDesignation } = useSelector((state) => state?.createDesignation);
    const { bulkUploadDesignations } = useSelector((state) => state?.bulkUploadDesignations);



    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }

    const [loading, setLoading] = useState(false);




    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)


        if (values?.file === null) {
            const data1 = {
                data: {
                    designation_name: values?.designation
                },
                method: editData?.designation_id ? "put" : "post",
                apiName: editData?.designation_id ? `updateDesignation/${editData?.designation_id}` : "createDesignation"
            };
            const responseData = await dispatch(editData?.designation_id ? actions.UPDATEDESIGNATION(data1) : actions.CREATEDESIGNATION(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Designation fetched successfully.") {
                setLoading(false)
                toast.success("Designation fetched successfully.")
                resetForm()
            } else if (responseData?.payload?.message === "Designation updated.") {
                setLoading(false)
                toast.success("Designation upadated successfully.")
                setEditData()
            }
            else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }
        } else {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUploadDesignations/bulk"
            };
            const responseData = await dispatch(actions.BULKUPLOADDESIGNATION(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk upload successful.") {
                setLoading(false)
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen(true)
                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }



    }

    // const handleSamplDownload = () => {
    //     // const data1 = {
    //     //     data: {},
    //     //     method: "get",
    //     //     apiName: "downloadAllDesignations/excel"
    //     // };
    //     // const responseData = dispatch(actions.DOWNLOADALLDESIGNATIONS(data1));

    //     window.open(`${adminUrl}downloaddesignationssampleexcelfile`);

    // }

    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloaddesignationssampleexcelfile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Designation_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")


    const { getAllDesignations } = useSelector((state) => state?.getAllDesignations);
    console.log(getAllDesignations, "getAllDesignations")


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllDesignations"
            };
            const responseData = dispatch(actions.GETALLDESIGNATIONS(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [updateDesignation, createDesignation, bulkUploadDesignations])

    useEffect(() => {

        const tempArr = [];

        getAllDesignations?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.designation_id,
                designation_name: data?.designation_name
            });
        });
        setRowTableData(tempArr);




    }, [getAllDesignations])




    const { getDesignationById } = useSelector((state) => state?.getDesignationById);


    const handleTableEdit = async (id) => {
        setLoading(true)
        setShowExcelUpload(false)
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top

        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getDesignationById/${id}`
        };
        const responseData = await dispatch(actions.GETDESIGNATIONBYID(data1));
        console.log(responseData, "getDesignationById")
        if (responseData?.payload?.message === "All Designation fetched successfully.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }



    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        {showExcelUpload ? 'Upload Excel' : 'Add Designation'}
                    </Typography>
                    <Typography
                        variant='body1'
                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }}
                        sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography>
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        designation: editData?.designation_name || '',
                        file: null
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    {showExcelUpload ? (
                                        <>
                                            <CustomExcelUpload
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                resetForm={resetForm}
                                            />
                                            {/* <Typography variant='body1'
                                                sx={{
                                                    // borderBottom: "1px solid var(--main-color)",
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >Download & Sample Excel Format</Typography> */}
                                            {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                            <Typography
                                                onClick={handleSamplDownload}
                                                variant="body1"
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >
                                                Download & Sample Excel Format
                                            </Typography>
                                            {/* </a>/ */}

                                        </>
                                    ) : (
                                        <CustomInputForm
                                            custPlaceholder="Enter Designation"
                                            name="designation"
                                            label="Designation"
                                        />
                                    )}
                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 4 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        {editData?.designation_id ? "Update" : "Submit"}

                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <CustomTable
                    tableHeadData={tableHeadData}
                    tableData={rowTableData}
                    title="Destination List"
                    tableEdit={true}
                    tableActions={true}
                    tableSearch={true}

                    handleTableEdit={handleTableEdit}

                />
            </Box>
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
            <InvalidRowsModal name="designation" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />


        </Box>
    );
};

export default Designation;
